<form novalidate [formGroup]="_form" class="form_style">
  @if (_showSeparator || pageState == 4) {
    <div class="Customseparator"></div>
  }
  @if (pageState == 4) {
    <!-- <div class="dragingHeader">you can Drag and drop Custom Fields to Reorder<span>*</span></div> -->
    <kendo-sortable [kendoSortableBinding]="visibleCustomFields"
      [navigable]="true"
      [animation]="true"
      class="col-12 zeroPaddingColumn"
      [emptyItemClass]="pageState == 4 ? 'item-empty-edit' : 'item-empty'"
      itemClass="reordered-item col-12 zeroPaddingColumn"
      activeItemClass="active-reordered-item"
      zone="innerZone"
      (dataMove)="dataMove(visibleCustomFields[$event.index], visibleCustomFields[$event.oldIndex])"
      (dragEnd)="dragEnd()">
      <ng-template let-item="item">
        @if (getAuthByName(item.name).canView) {
          <div KendoToolTip
            class="form-group special_style_formgroup"
            [class.customFieldsForm]="pageState == 4"
            [class.k-combobox_mend]="item.customFieldType.type == 'Dropdown'">
            <a [class.editfieldsIconvisible]="pageState == 4"
              class="editFieldsIcon">
              <img class="searchIcon"
                [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
              </a>
              <label [for]="item.id" class="control-label">{{ item.name }}</label>
              @switch (item.customFieldType.type) {
                @case ('String') {
                  <ng-container KendoToolTip>
                    <input type="text"
                      [formControlName]="item.name"
                      (change)="_onCustomFieldChange()"
                      class="k-textbox writebox newFormControlWidth"
                      [placeholder]="item.name"
                      [value]="item.value"
                      [required]="item.isRequired"
                      [disabled]="!getAuthByName(item.name).canEdit" />
                      <a title="Edit {{item.name}}"
                        [class.editfieldsIconvisible]="pageState == 4"
                        class="editFieldsIcon"
                        (click)="_openeditCustomFields(item.id)">
                        <img class="searchIcon"
                          [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                        </a>
                        <a title="Deactivate {{item.name}}"
                          [class.editfieldsIconvisible]="pageState == 4"
                          class="editFieldsIcon borderleft_image"
                          (click)="_deleteCustomFields(item.id, item)">
                          <img class="searchIcon"
                            [src]="'/assets/menu/'+ _theme +'/deactivate-fields-icon.svg'" />
                          </a>
                        </ng-container>
                      }
                      @case ('Numeric') {
                        <ng-container KendoToolTip>
                          <kendo-numerictextbox type="number"
                            [formControlName]="item.name"
                            (blur)="_onCustomFieldChange()"
                            [placeholder]="item.name"
                            [value]="0"
                            class="k-numerictextbox newFormControlWidth"
                            [required]="item.isRequired"
                            [disabled]="!getAuthByName(item.name).canEdit"
                            [ngClass]="{'bordered': item.isRequired}">
                          </kendo-numerictextbox>
                          <a title="Edit {{item.name}}"
                            [class.editfieldsIconvisible]="pageState == 4"
                            class="editFieldsIcon"
                            (click)="_openeditCustomFields(item.id)">
                            <img class="searchIcon"
                              [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                            </a>
                            <a title="Deactivate {{item.name}}"
                              [class.editfieldsIconvisible]="pageState == 4"
                              class="editFieldsIcon"
                              (click)="_deleteCustomFields(item.id, item)">
                              <img class="searchIcon"
                                [src]="'/assets/menu/'+ _theme +'/deactivate-fields-icon.svg'" />
                              </a>
                            </ng-container>
                          }
                          @case ('Date') {
                            <ng-container KendoToolTip>
                              <kendo-datetimepicker type="date"
                                [format]="_modelformat"
                                [formControlName]="item.name"
                                (valueChange)="_onCustomFieldChange()"
                                [placeholder]="item.name"
                                class="newFormControlWidth datepickerControlrightMargin"
                                [required]="item.isRequired"
                                [disabled]="!getAuthByName(item.name).canEdit"
                              [ngClass]="{'bordered': item.isRequired}"></kendo-datetimepicker>
                              <a title="Edit {{item.name}}"
                                [class.editfieldsIconvisible]="pageState == 4"
                                class="editFieldsIcon"
                                (click)="_openeditCustomFields(item.id)">
                                <img class="searchIcon withMargin"
                                  [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                </a>
                                <a title="Deactivate {{item.name}}"
                                  [class.editfieldsIconvisible]="pageState == 4"
                                  class="editFieldsIcon"
                                  (click)="_deleteCustomFields(item.id, item)">
                                  <img class="searchIcon"
                                    [src]="'/assets/menu/'+ _theme +'/deactivate-fields-icon.svg'" />
                                  </a>
                                </ng-container>
                              }
                              @case ('URL') {
                                <ng-container KendoToolTip>
                                  <input type="url"
                                    [formControlName]="item.name"
                                    (change)="_onCustomFieldChange()"
                                    [placeholder]="item.name"
                                    class="k-textbox writebox newFormControlWidth"
                                    [required]="item.isRequired"
                                    [disabled]="!getAuthByName(item.name).canEdit" />
                                    <a title="Edit {{item.name}}"
                                      [class.editfieldsIconvisible]="pageState == 4"
                                      class="editFieldsIcon"
                                      (click)="_openeditCustomFields(item.id)">
                                      <img class="searchIcon"
                                        [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                      </a>
                                      <a title="Deactivate {{item.name}}"
                                        [class.editfieldsIconvisible]="pageState == 4"
                                        class="editFieldsIcon"
                                        (click)="_deleteCustomFields(item.id, item)">
                                        <img class="searchIcon"
                                          [src]="'/assets/menu/'+ _theme +'/deactivate-fields-icon.svg'" />
                                        </a>
                                      </ng-container>
                                    }
                                    @case ('Dropdown') {
                                      <ng-container KendoToolTip>
                                        <kendo-combobox [data]="_customFieldsDataFiltered[item.id]"
                                          (valueChange)="_onCustomFieldChange()"
                                          [suggest]="true"
                                          [placeholder]="item.name"
                                          [formControlName]="item.name"
                                          [filterable]="true"
                                          (filterChange)="_handleFilter(item.id, $event)"
                                          [textField]="'value'"
                                          [valueField]="'id'"
                                          class="bordered newFormControlWidth"
                                          [required]="item.isRequired"
                                        [disabled]="!getAuthByName(item.name).canEdit"></kendo-combobox>
                                        <a title="Edit {{item.name}}"
                                          [class.editfieldsIconvisible]="pageState == 4"
                                          class="editFieldsIcon"
                                          (click)="_openeditCustomFields(item.id)">
                                          <img class="searchIcon"
                                            [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                          </a>
                                          <a title="Deactivate {{item.name}}"
                                            [class.editfieldsIconvisible]="pageState == 4"
                                            class="editFieldsIcon"
                                            (click)="_deleteCustomFields(item.id, item)">
                                            <img class="searchIcon"
                                              [src]="'/assets/menu/'+ _theme +'/deactivate-fields-icon.svg'" />
                                            </a>
                                          </ng-container>
                                        }
                                      }
                                    </div>
                                  }
                                </ng-template>
                              </kendo-sortable>
                            }

                            @if (pageState != 4) {
                              @for (element of visibleCustomFields; track element) {
                                @if (getAuthByName(element.name).canView) {
                                  <div kendoTooltip
                                    class="form-group special_style_formgroup customFieldsForm"
                                    [class.customFieldsForm]="pageState == 4"
                                    [class.k-combobox_mend]="element.customFieldType.type == 'Dropdown'">
                                    <label for="element.id" class="control-label">{{ element.name }}</label>
                                    @switch (element.customFieldType.type) {
                                      @case ('String') {
                                        <input type="text"
                                          [formControlName]="element.name"
                                          (change)="_onCustomFieldChange()"
                                          class="k-textbox writebox newFormControlWidth"
                                          [placeholder]="element.name"
                                          [value]="element.value"
                                          [required]="element.isRequired"
                                          [disabled]="!getAuthByName(element.name).canEdit || pageState == 1" />
                                          <a title="Edit {{element.name}}"
                                            [class.editfieldsIconvisible]="pageState == 4"
                                            class="editFieldsIcon"
                                            (click)="_openeditCustomFields(element.id)">
                                            <img class="searchIcon"
                                              [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                            </a>
                                            <a title="Deactivate {{element.name}}"
                                              [class.editfieldsIconvisible]="pageState == 4"
                                              class="editFieldsIcon"
                                              (click)="_deleteCustomFields(element.id, element)">
                                              <img class="searchIcon"
                                                [src]="'/assets/menu/'+ _theme +'/deactivate-fields-icon.svg'" />
                                              </a>
                                            }
                                            @case ('Numeric') {
                                              <!-- [attr.disabled]="getAuthByName(element.name).canEdit ? null : 'disabled'" -->
                                              <kendo-numerictextbox type="number"
                                                [formControlName]="element.name"
                                                (blur)="_onCustomFieldChange()"
                                                [placeholder]="element.name"
                                                [value]="0"
                                                class="k-numerictextbox newFormControlWidth"
                                                [required]="element.isRequired"
                                                [disabled]="!getAuthByName(element.name).canEdit || pageState == 1"
                                                [ngClass]="{'bordered': element.isRequired}">
                                              </kendo-numerictextbox>
                                              <a title="'Edit {{element.name}}"
                                                [class.editfieldsIconvisible]="pageState == 4"
                                                class="editFieldsIcon"
                                                (click)="_openeditCustomFields(element.id)">
                                                <img class="searchIcon"
                                                  [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                                </a>
                                                <a title="'Deactivate {{element.name}}"
                                                  [class.editfieldsIconvisible]="pageState == 4"
                                                  class="editFieldsIcon"
                                                  (click)="_deleteCustomFields(element.id, element)">
                                                  <img class="searchIcon"
                                                    [src]="'/assets/menu/'+ _theme +'/deactivate-fields-icon.svg'" />
                                                  </a>
                                                }
                                                @case ('Date') {
                                                  <ng-container kendoTooltip>
                                                    <kendo-datetimepicker type="date"
                                                      [format]="_modelformat"
                                                      [formControlName]="element.name"
                                                      (valueChange)="_onCustomFieldChange()"
                                                      [placeholder]="element.name "
                                                      class="newFormControlWidth datepickerControlrightMargin"
                                                      [required]="element.isRequired"
                                                      [disabled]="!getAuthByName(element.name).canEdit || pageState == 1"
                                                    [ngClass]="{'bordered': element.isRequired}"></kendo-datetimepicker>
                                                    <a title="Edit {{element.name}}"
                                                      [class.editfieldsIconvisible]="pageState == 4"
                                                      class="editFieldsIcon"
                                                      (click)="_openeditCustomFields(element.id)">
                                                      <img class="searchIcon"
                                                        [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                                      </a>
                                                      <a title="Deactivate {{element.name}}"
                                                        [class.editfieldsIconvisible]="pageState == 4"
                                                        class="editFieldsIcon"
                                                        (click)="_deleteCustomFields(element.id, element)">
                                                        <img class="searchIcon"
                                                          [src]="'/assets/menu/'+ _theme +'/deactivate-fields-icon.svg'" />
                                                        </a>
                                                      </ng-container>
                                                    }
                                                    @case ('URL') {
                                                      <ng-container kendoTooltip>
                                                        <input #UrlField
                                                          type="url"
                                                          [formControlName]="element.name"
                                                          (blur)="_onCustomFieldChange()"
                                                          [placeholder]="element.name"
                                                          class="k-textbox writebox newFormControlWidth"
                                                          [disabled]="!getAuthByName(element.name).canEdit || pageState == 1"
                                                          [required]="element.isRequired" />
                                                          <!-- Item Here  -->
                                                          <a class="editfieldsIconvisible" (click)="GotoUrl()">
                                                            <img class="searchIcon"
                                                              [src]="'/assets/images/icons/google-url-icon.svg'" />
                                                            </a>
                                                            <a title="Edit {{element.name}}"
                                                              [class.editfieldsIconvisible]="pageState == 4"
                                                              class="editFieldsIcon"
                                                              (click)="_openeditCustomFields(element.id)">
                                                              <img class="searchIcon"
                                                                [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                                              </a>
                                                              <a title="Deactivate {{element.name}}"
                                                                [class.editfieldsIconvisible]="pageState == 4"
                                                                class="editFieldsIcon"
                                                                (click)="_deleteCustomFields(element.id, element)">
                                                                <img class="searchIcon"
                                                                  [src]="'/assets/menu/'+ _theme +'/deactivate-fields-icon.svg'" />
                                                                </a>
                                                              </ng-container>
                                                            }
                                                            @case ('Dropdown') {
                                                              <ng-container kendoTooltip>
                                                                <kendo-combobox [data]="_customFieldsDataFiltered[element.id]"
                                                                  (valueChange)="_onCustomFieldChange()"
                                                                  [suggest]="true"
                                                                  [placeholder]="element.name"
                                                                  [formControlName]="element.name"
                                                                  [filterable]="true"
                                                                  (filterChange)="_handleFilter(element.id, $event)"
                                                                  [textField]="'value'"
                                                                  [valueField]="'id'"
                                                                  class="bordered newFormControlWidth"
                                                                  [required]="element.isRequired"
                                                                [disabled]="!getAuthByName(element.name).canEdit || pageState == 1"></kendo-combobox>
                                                                <a title="Edit {{element.name}}" [class.editfieldsIconvisible]="pageState == 4" class="editFieldsIcon" (click)="_openeditCustomFields(element.id)">
                                                                  <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                                                </a>
                                                                <a title="Deactivate {{element.name}}"
                                                                  [class.editfieldsIconvisible]="pageState == 4"
                                                                  class="editFieldsIcon"
                                                                  (click)="_deleteCustomFields(element.id, element)">
                                                                  <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/deactivate-fields-icon.svg'" />
                                                                </a>
                                                              </ng-container>
                                                            }
                                                          }
                                                        </div>
                                                      }
                                                    }
                                                  }
                                                  <div class="row">
                                                    <div class="col-12">
                                                      <!-- <asap-forms-validation-summary *ngIf="_invalidForm || invalidSubmit" [form]="_form" [page]="page" [isCustom]="true">
                                                    </asap-forms-validation-summary> -->
                                                  </div>
                                                </div>
                                              </form>
